/* unplugin-vue-components disabled */import { render } from "./member_science_more.vue?vue&type=template&id=5e53d721&scoped=true"
import script from "./member_science_more.vue?vue&type=script&lang=js"
export * from "./member_science_more.vue?vue&type=script&lang=js"

import "./member_science_more.vue?vue&type=style&index=0&id=5e53d721&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e53d721"]])

export default __exports__